import { render, staticRenderFns } from "./RedshiftInfo.vue?vue&type=template&id=04513918&"
import script from "./RedshiftInfo.vue?vue&type=script&lang=js&"
export * from "./RedshiftInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports